import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import TenantBidPayment from './tenant-bid-payment';
import TenantBidPaymentDetail from './tenant-bid-payment-detail';
import TenantBidPaymentUpdate from './tenant-bid-payment-update';
import TenantBidPaymentDeleteDialog from './tenant-bid-payment-delete-dialog';

const TenantBidPaymentRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<TenantBidPayment />} />
    <Route path="new" element={<TenantBidPaymentUpdate />} />
    <Route path=":id">
      <Route index element={<TenantBidPaymentDetail />} />
      <Route path="edit" element={<TenantBidPaymentUpdate />} />
      <Route path="delete" element={<TenantBidPaymentDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default TenantBidPaymentRoutes;
